import { render, staticRenderFns } from "./StockMovementHistory.vue?vue&type=template&id=3950b94f&scoped=true&"
import script from "./StockMovementHistory.vue?vue&type=script&lang=js&"
export * from "./StockMovementHistory.vue?vue&type=script&lang=js&"
import style0 from "./StockMovementHistory.vue?vue&type=style&index=0&id=3950b94f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3950b94f",
  null
  
)

export default component.exports